import { passCodes } from '../passCodes';
import track4 from '../../../../assets/audio/tracks/track4.mp3';

const hints = [
    {
        text: 'Vzpomínejte, co delfín říkal, že máte sledovat.',
    },
    {
        text: 'Kódem je: straka',
        solution: true,
    },
];
export const step4cafe = {
    id: 4,
    title: '2. stanoviště',
    taskText: `
        <p>
            Aaa už to vidím, co by na té tabulce opodál mohlo být tak speciálního. Samá jména, ale no jo, přece jenom jedno z nich dává na základě toho, co řekl ten potrhlý delfín smysl.
        </p>          
    `,
    catImage: 1,
    cipher: {
        text: 'Zadejte jméno, které Míša myslí. Použijte tabulku, kterou naleznete někde v okolí. Dáme vám malou nápovědu, z místa, na kterém stojíte byste měli vidět kavárnu P-café.',
        label: 'Úkol',
    },
    audio: track4,
    snowAudio: track4,
    codeInputText: ' ',
    codeInputPassCodeRegexp: passCodes[1],
    additionalInfo: 'Odpovědí je jedno slovo.',
    hints: hints,
    snowHints: hints,
};
